





























































import { Component, Vue, Watch } from "vue-property-decorator";
import { IPermission } from "@/shared/model/permission.model";
import PermissionService from "@/entities/permission/permission.service";
import UserPrivilegeService from "@/entities/user-privilege/user-privilege.service";
import UserManagementService from "@/admin/user-management/user-management.service";
import { CREATE_MAP, CREATE_MAP_KEY_TO_LIST_CUSTOM_KEY, viewPageToQueryPage } from "@/constants";
import ProjectService from "@/entities/project/project.service";
import { IUserPrivilege } from "@/shared/model/user-privilege.model";

@Component
export default class PermissionListPage extends Vue {
  headers = [
    // { text: 'ID', value: 'id' },
    {
      text: 'Họ tên',
      value: 'fullname',
      sortable: false,
    },
    // { text: 'Mail', value: 'mail' },
    {
      text: 'Mail',
      value: 'login',
      sortable: false,
    },
    { text: 'Mobile', value: 'mobileLogin', sortable: false },

    { text: 'Phân quyền', value: 'permissions', sortable: false },
  ];

  permissionHeaders = [
    { text: 'Tên dự án', value: 'projectName' },
    { text: 'Các quyền', value: 'permissionNames', sortable: false },
  ];

  users = [];
  userToUserPrivilege = {};
  userToPermissions = {};

  get userFilter() {
    return this.users.filter(user => {
      return (
        user.firstName.toLowerCase().includes(this.searchByNameValue.toLowerCase()) ||
        user.lastName.toLowerCase().includes(this.searchByNameValue.toLowerCase()) ||
        user.login.toLowerCase().includes(this.searchByNameValue.toLowerCase())
      );
    });
  }

  userPage = {
    page: 1,
    size: 500,
    total: 500,
  };
  loading = false;
  userMobileAccesses = {};

  searchByNameValue = '';

  changeMobileAccess(item, value) {
    new UserPrivilegeService().partialUpdate({ id: item.userPrivilege.id, mobileAccessEnabled: value });
  }

  mounted() {
    this.fetchUsers();
  }

  @Watch('userPage.page')
  @Watch('userPage.size')
  async fetchUsers() {
    this.loading = true;
    let userManagementService = new UserManagementService();
    let userRs = await userManagementService.retrieve(viewPageToQueryPage(this.userPage));
    this.users = userRs.data;
    // sort ignore case
    this.users.sort((a, b) => {
      if (a.login < b.login) return -1;
      if (a.login > b.login) return 1;
      return 0;
    });
    this.userPage.total = Number(userRs.headers['x-total-count']);

    this.userToUserPrivilege = {};
    this.userToPermissions = {};

    let userPrivilegeService = new UserPrivilegeService();
    let userPrivileges = await userPrivilegeService.findByIdList(this.users.map((user: any) => user.id));
    userPrivileges.forEach((userPrivilege: IUserPrivilege) => {
      this.userToUserPrivilege[userPrivilege.id] = userPrivilege;
    });
    this.users.map(user => {
      this.userMobileAccesses[user.id] = user.userPrivilege.mobileAccessEnabled;
    });
    let userPrivilegeMap = CREATE_MAP(userPrivileges);

    let { findByUserIdList } = new PermissionService();
    let projectIds: number[] = [];
    let permissions: IPermission[] = (
      await findByUserIdList(
        Object.values(this.userToUserPrivilege).map((userPrivilege: IUserPrivilege) => {
          return userPrivilege.id;
        })
      )
    ).data;
    this.userToPermissions = CREATE_MAP_KEY_TO_LIST_CUSTOM_KEY(permissions, e => userPrivilegeMap[e.userPrivilege.id].user.id);
    projectIds.push(...permissions.map((permission: IPermission) => permission.project.id));

    let projectService = new ProjectService();
    if (projectIds.length > 0) {
      projectService.findList(projectIds).then(projects => {
        let projectMap = CREATE_MAP(projects);
        permissions.forEach(permission => {
          let project = permission.project;
          Object.assign(project, projectMap[project.id]);
        });
      });
    }
    this.loading = false;
  }

  get userMap() {
    return CREATE_MAP(this.users);
  }

  deletePermission() {}
}
